import axios from 'axios'

export const fetchCustomQuestions = async () => {
  const baseURL = window.location.origin
  const {
    data: { custom_questions },
  } = await axios.get(`${baseURL}/api/v1/dealer/autorama/custom_questions`)
  return custom_questions
}
